import resizeLogic from './resizeLogic';
import fetchUserDataLogic from './fetchUserDataLogic';
import authenticationLogic from './authenticationLogic';
import appToggleLogic from './appToggleLogic';
import phoneNumberLogic from './phoneNumberLogic';
import postPersonalInfoLogic from './postPersonalInfoLogic';
import shippingAddressesLogic from './shippingAddressesLogic';
import updateAccountLogic from './updateAccountLogic';
import creditCardsLogic from './creditCardsLogic';
import paymentMethodsToggleLogic from './paymentMethodsToggleLogic';
import countryServiceLogic from './countryServiceLogic';
import billingAccountsLogic from './billingAccountsLogic';
import giftCardLogic from './giftCardLogic';
import tableLogic from './tableLogic';
import orderLogic from './orderLogic';
import billingAcctDetailsLogic from './billingAcctDetailsLogic';
import invoiceLogic from './invoiceLogic';
import digitalMediaLogic from './mediaContentLogic';
import redeemCodeLogic from './redeemCodeLogic';
import pinLogic from './pinLogic';
import subscriptionsLogic from './subscriptionLogic';
import licenseAccessLogic from './licenceAccessLogic';
import productLogic from './productLogic';
import analyticsLogic from './analyticsLogic';
import braintreeLogic from './braintreeLogic';
import paymentsLogic from './paymentsLogic';
import paymentTokenLogic from './paymentTokenLogic';
import switchOrgsLogic from './switchOrgsLogic';
import thirdPartyAccountLogic from './thirdPartyAccountLogic';
import linkedOrganizationsLogic from './linkedOrganizationsLogic';
import invitationLogic from './invitationLogic';
import achPaymentMethodsLogic from './achPaymentMethodsLogic';

export default [
  ...resizeLogic,
  ...appToggleLogic,
  ...phoneNumberLogic,
  // TODO: consolidate logic into single file.
  fetchUserDataLogic,
  ...postPersonalInfoLogic,
  ////////////////////////////////////////////
  ...authenticationLogic,
  ...shippingAddressesLogic,
  ...updateAccountLogic,
  ...creditCardsLogic,
  ...paymentMethodsToggleLogic,
  ...countryServiceLogic,
  ...billingAccountsLogic,
  ...giftCardLogic,
  ...tableLogic,
  ...orderLogic,
  ...billingAcctDetailsLogic,
  ...invoiceLogic,
  ...digitalMediaLogic,
  ...redeemCodeLogic,
  ...pinLogic,
  ...subscriptionsLogic,
  ...licenseAccessLogic,
  ...productLogic,
  ...analyticsLogic,
  ...braintreeLogic,
  ...paymentsLogic,
  ...paymentTokenLogic,
  ...switchOrgsLogic,
  ...thirdPartyAccountLogic,
  ...linkedOrganizationsLogic,
  ...invitationLogic,
  ...achPaymentMethodsLogic,
];
